// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"92849a15","592":"2f40841d","952":"15f34cec"}[chunkId] + ".chunk.js";
};